import './Home.css'

import React from 'react'
import NavigationBar from '../NavigationBar/NavigationBar'
import SideBar from './SideBar'
import Chat from './Chat'

function Home() {
  return (
    <div>
      <NavigationBar />
      <div className="home">
        <div className="HomeContainer">
          <SideBar />
          <Chat />
        </div>
      </div>
    </div>
  )
}

export default Home
